// extracted by mini-css-extract-plugin
export default {"filterSearchIcon":"src-components-Filter-next-components-SbSearchBar__filterSearchIcon--fUK0h"};